// Import Views

// Dashboard
import Home from './views/Home';
import Play from './views/Play';

import {
  HomeIcon,
  SettingsIcon
} from './components/Icons/Icons';

export const main = [
  {
    path: '/',
    name: 'Home',
    icon: <HomeIcon color="inherit" />,
    component: Home,
    layout: '/',
  },
  {
    path: 'play',
    name: 'Home',
    icon: <HomeIcon color="inherit" />,
    component: Play,
    layout: '/',
  }
];


const routes = [...main];
export default routes;